import Banner from "./Banner";

import IBanner, { BannerVariant } from "./BannerTypes";

export type {
  IBanner,
  BannerVariant
}

export default Banner;